<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="cv_custname,cv_contect,clientvisit.creatorName"
      placeholder="输入客户、人员查找"
      ref="searchBar"
    />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/crm/client_visit/' + item.id"
      >
        <div class="weui-cell__bd">
          <p>{{ item.cv_code }}</p>
          <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{ item.cv_date }}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{ item.cv_custname }}</p>
          <span
            class="list-item-status"
            :class="{ warning: item.cv_statuscode == 'UNAUDITED' }"
            >{{ item.cv_status }}</span
          >
        </div>
      </router-link>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">合计：{{ items.length }}次</label>
    </div>
    <add-button to="/crm/client_visit_edit"/>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import AddButton from "@/components/button/Add.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
    AddButton
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/crm/clientvisit/list",
      filters: [
        {
          type: "date",
          name: "cv_date",
        },
        {
          type: "condition",
          label: "状态",
          value: -1,
          options: [
            {
              value: -1,
              label: "全部",
            },
            {
              value: 1,
              label: "待审核",
              condition: "cv_status='未审核'",
            },
            {
              value: 2,
              label: "已审核",
              condition: "cv_status='已审核'",
            },
          ],
        },
      ],
    };
  },
};
</script>